import React, { useCallback } from 'react';
import { EditRedistributionData } from '../editRedistributionLib';
import { Column, DataTable, GreyFlex } from '@ydistri/ds';
import { SkuRedistributionResponse } from '@ydistri/api-sdk';
import { useSkuRedistributionTableColumns } from '../../Redistribution/parts/listing/components/SkuRedistributionTable/useSkuRedistributionTableColumns';
import { useDeletePickingPositionsMutation } from '../apiCalculationEdit';
import { useAppDispatch } from '../../../../store';
import { addToast } from '@ydistri/utils';
import { closeModal } from '../../../Modals/modalSlice';
import { processErrorAndShowToast } from '../../../../lib/utils/processErrorAndShowToast';
import { useSearchParams } from 'react-router';
import { selectSKURedistribution } from '../../../Calculations/calculationsSlice';
import BackupOrRemoveButton from '../BackupOrRemoveButton';
import { computeRemSize } from '@ydistri/theme';

type EditRedistributionPickingPositionProps = Pick<
  EditRedistributionData,
  'calculationId' | 'pickingPosition'
>;

const EditRedistributionPickingPosition: React.FC<EditRedistributionPickingPositionProps> = ({
  calculationId,
  pickingPosition,
}) => {
  const columns = useSkuRedistributionTableColumns();
  const dispatch = useAppDispatch();
  const [deletePickingPositions, deleteStatus] = useDeletePickingPositionsMutation();
  const [, setSearchParams] = useSearchParams();

  const handleDelete = useCallback(() => {
    if (!pickingPosition) return;
    deletePickingPositions({
      calculationId,
      pickingPositions: [
        {
          sourceSkuId: pickingPosition.sourceSku.skuId,
          targetSkuId: pickingPosition.targetSku.skuId,
          description: 'Removed one picking position',
          entityDetail: JSON.stringify(pickingPosition),
        },
      ],
    })
      .then(() => {
        setSearchParams({ p: '' });
        dispatch(selectSKURedistribution(undefined));
        dispatch(addToast({ message: `Picking position removed successfully.` }));
        dispatch(closeModal());
      })
      .catch(processErrorAndShowToast(dispatch, 'Removing a picking position failed'));
  }, [pickingPosition, deletePickingPositions, calculationId, dispatch, setSearchParams]);

  return (
    <Column $gap="2rem" $justifyContent="space-evenly" $padding={0}>
      <div style={{ minHeight: computeRemSize(400) }}>
        <DataTable<SkuRedistributionResponse>
          id="edit-redistribution-single-picking-position-table"
          showHeader={true}
          columns={columns}
          height={computeRemSize(400)}
          dataSource={pickingPosition ? [pickingPosition] : []}
        />
      </div>
      <GreyFlex $gap="2rem" $alignItems="center" $justifyContent="end">
        <BackupOrRemoveButton
          calculationId={calculationId}
          loading={deleteStatus.isLoading}
          onClick={handleDelete}
        />
      </GreyFlex>
    </Column>
  );
};

export default EditRedistributionPickingPosition;
